import React, { useEffect, useState } from "react";

import { Link, useNavigate, useLocation } from "react-router-dom";
import { setProfileSlice } from "../redux/slices/profile_slice";
import { useDispatch, useSelector } from "react-redux";
import api from "services/api";
import { useAuth } from "hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faBook,
  faFeather,
  faFileCirclePlus,
  faHandHoldingDollar,
  faHandshake,
  faHouse,
  faPaperclip,
  faPenNib,
  faPeopleArrows,
  faPhone,
  faRadio,
  faUser,
  faUserGear,
  faUserShield,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";

export const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.profile.profileDataRedux);
  const [dashboardMenu, setDashBoardMenu] = useState("");
  const { user, removeToken } = useAuth();
  const isLoggedIn = localStorage.getItem("user");
  const location = useLocation();
  const { pathname } = location;
  const [accountMenu, setAccountMenu] = useState("");
  const [paymentMenu, setPaymentMenu] = useState("");
  const [helpMenu, setHelpMenu] = useState("");

  const handleLogout = () => {
    api
      .post("/logout", {})
      .then((res) => {
        removeToken();
        navigate("/");
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    }

    window.scrollTo(0, 0);
  }, []);

  const fetchUserDetails = async () => {
    try {
      const response = await api.get(`/users/${user?.user_id}`);
      const data = response?.data?.data?.user;
      dispatch(setProfileSlice(data));
    } catch (error) {
      console.log("error response:", error);
    }
  };
  useEffect(() => {
    if (!userData) {
      fetchUserDetails();
    }
  }, []);

  const handleDashboardMenu = () => {
    if (dashboardMenu === "open") {
      setDashBoardMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setDashBoardMenu("");
      }, 200);
    } else {
      setDashBoardMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setDashBoardMenu("open");
      }, 200);
    }
  };

  const handleAccountMenu = () => {
    if (accountMenu === "open") {
      setAccountMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setAccountMenu("");
      }, 200);
    } else {
      setAccountMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setAccountMenu("open");
      }, 200);
    }
  };
  const handlePaymentMenu = () => {
    if (paymentMenu === "open") {
      setPaymentMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setPaymentMenu("");
      }, 200);
    } else {
      setPaymentMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setPaymentMenu("open");
      }, 200);
    }
  };
  const handleHelpMenu = () => {
    if (helpMenu === "open") {
      setHelpMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setHelpMenu("");
      }, 200);
    } else {
      setHelpMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setHelpMenu("open");
      }, 200);
    }
  };
  return (
    <nav
      className="layout-navbar shadow-none py-0"
      style={{ position: "sticky", top: "0px" }}
    >
      <div className="container">
        <div
          className="navbar navbar-expand-lg landing-navbar px-3 px-md-4"
          style={{ backgroundColor: "#fff" }}
        >
          <div className="navbar-brand app-brand demo d-flex py-0 py-lg-2 me-4">
            <button
              className="navbar-toggler border-0 px-0 me-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="ti ti-menu-2 ti-sm align-middle" />
            </button>

            <Link to="/" className="app-brand-link d-md-none">
              <span className="app-brand-logo demo">
                <img
                  src="../../assets/img/flowersvg.svg"
                  style={{
                    width: "40px",
                    height: "26px",
                    borderRadius: "50%",
                  }}
                />
              </span>
              <span class="app-brand-text demo menu-text fw-bold">
                Zenosure
              </span>
            </Link>
          </div>
          <div
            className="collapse navbar-collapse landing-nav-menu "
            id="navbarSupportedContent"
          >
            <button
              className="navbar-toggler border-0 text-heading position-absolute end-0 top-0 scaleX-n1-rtl"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="ti ti-x ti-sm" />
            </button>
            <aside
              id="layout-menu"
              className=" menu-vertical menu bg-menu-theme"
            >
              <ul className="menu-inner py-1 d-md-none">
                <li
                  className={`menu-item ${
                    pathname === "/dashboard" ||
                    pathname.startsWith("/dashBEnrollPI")
                      ? "active"
                      : ""
                  }`}
                >
                  <Link to="/dashboard" className="menu-link">
                    <div data-i18n="Dashboard">
                      <FontAwesomeIcon
                        icon={faBell}
                        size="xs"
                        className="me-2"
                      />
                      Dashboard
                    </div>
                  </Link>
                </li>
                <li
                  className={`menu-item ${
                    pathname === "/plans" ||
                    pathname.startsWith("/selectedPlan") ||
                    pathname.startsWith("/membershipForm")
                      ? "active"
                      : ""
                  }`}
                >
                  <Link to="/plans" className="menu-link ">
                    <div data-i18n="Dashboard">
                      {" "}
                      <FontAwesomeIcon
                        icon={faHouse}
                        size="xs"
                        className="me-2"
                      />
                      Plans
                    </div>
                  </Link>
                </li>

                <li
                  className={`menu-item ${
                    pathname === "/enrolledPlans" ||
                    pathname.startsWith("/enrollApplicationDetailsForm") ||
                    pathname.startsWith("/membershipDetails")
                      ? "active"
                      : ""
                  }`}
                >
                  <Link to="/enrolledPlans" className="menu-link ">
                    <div data-i18n="Dashboard">
                      {" "}
                      <FontAwesomeIcon
                        icon={faPeopleArrows}
                        size="xs"
                        className="me-2"
                      />
                      Your plans
                    </div>
                  </Link>
                </li>

                <li className={`menu-item ${pathname === "/kyc" && "active"}`}>
                  <Link to="/kyc" className="menu-link ">
                    <div data-i18n="Dashboard">
                      {" "}
                      <FontAwesomeIcon
                        icon={faFileCirclePlus}
                        size="xs"
                        className="me-2"
                      />
                      KYC
                    </div>
                  </Link>
                </li>

                <li
                  className={`menu-item active ${dashboardMenu} ${
                    (pathname === "/profile" ||
                      pathname === "/updateProfile") &&
                    "open"
                  }`}
                  onClick={handleDashboardMenu}
                >
                  <Link
                    to="javascript:void(0);"
                    className="menu-link menu-toggle"
                  >
                    <div data-i18n="Dashboard">
                      <FontAwesomeIcon
                        icon={faUserGear}
                        size="xs"
                        className="me-2"
                      />
                      Settings
                    </div>
                  </Link>
                  <ul className="menu-sub" style={{ listStyle: "none" }}>
                    <li
                      className={`menu-item ${
                        pathname === "/profile" || pathname === "/updateProfile"
                          ? "active"
                          : ""
                      }`}
                    >
                      <Link to="/profile" className="menu-link">
                        <FontAwesomeIcon
                          icon={faUser}
                          size="xs"
                          className="me-2"
                        />{" "}
                        Profile
                      </Link>
                    </li>
                  </ul>
                </li>

                <li
                  className={`menu-item active ${accountMenu} ${
                    (pathname === "/setPassword" ||
                      pathname === "/securityTerms") &&
                    "open"
                  }`}
                  onClick={handleAccountMenu}
                >
                  <Link
                    to="javascript:void(0);"
                    className="menu-link menu-toggle"
                  >
                    <div data-i18n="Account Settings">
                      <FontAwesomeIcon
                        icon={faUserShield}
                        size="xs"
                        className="me-2"
                      />{" "}
                      Security
                    </div>
                  </Link>
                  <ul className="menu-sub">
                    <li
                      className={`menu-item ${
                        pathname === "/setPassword" && "active"
                      }`}
                    >
                      <Link to="/setPassword" className="menu-link">
                        <div data-i18n="Account">
                          <FontAwesomeIcon
                            icon={faPenNib}
                            size="xs"
                            className="me-2"
                          />{" "}
                          Reset password
                        </div>
                      </Link>
                    </li>
                    <li
                      className={`menu-item ${
                        pathname === "/securityTerms" && "active"
                      }`}
                    >
                      <Link to="/securityTerms" className="menu-link">
                        <div data-i18n="Account">
                          <FontAwesomeIcon
                            icon={faPaperclip}
                            size="xs"
                            className="me-2"
                          />{" "}
                          Terms and condition
                        </div>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={`menu-item active ${paymentMenu} ${
                    (pathname === "/billing" ||
                      pathname === "/invoicerecept") &&
                    "open"
                  }`}
                  onClick={handlePaymentMenu}
                >
                  <Link
                    to="javascript:void(0);"
                    className="menu-link  menu-toggle"
                  >
                    <div data-i18n="Dashboard">
                      <FontAwesomeIcon
                        icon={faHandHoldingDollar}
                        size="xs"
                        className="me-2"
                      />{" "}
                      Manage payments
                    </div>
                  </Link>
                  <ul className="menu-sub">
                    <li
                      className={`menu-item ${
                        pathname === "/invoicerecept" && "active"
                      }`}
                    >
                      <Link to="/invoicerecept" className="menu-link">
                        <div data-i18n="Account">
                          <FontAwesomeIcon
                            icon={faBook}
                            size="xs"
                            className="me-2"
                          />{" "}
                          Invoice & receipt
                        </div>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={`menu-item active ${helpMenu} ${
                    (pathname === "/contactussid" || pathname === "/faqsid") &&
                    "open"
                  }`}
                  onClick={handleHelpMenu}
                >
                  <Link
                    to="javascript:void(0);"
                    className="menu-link menu-toggle"
                  >
                    <div data-i18n="Dashboard">
                      <FontAwesomeIcon
                        icon={faHandshake}
                        size="xs"
                        className="me-2"
                      />
                      Help
                    </div>
                  </Link>
                  <ul className="menu-sub">
                    <li
                      className={`menu-item ${
                        pathname === "/contactussid" && "active"
                      }`}
                    >
                      <Link to="/contactussid" className="menu-link">
                        <div data-i18n="Account">
                          <FontAwesomeIcon
                            icon={faPhone}
                            size="xs"
                            className="me-2"
                          />{" "}
                          Contact us
                        </div>
                      </Link>
                    </li>
                    <li
                      className={`menu-item ${
                        pathname === "/faqsid" && "active"
                      }`}
                    >
                      <Link to="/faqsid" className="menu-link">
                        <div data-i18n="Account">
                          <FontAwesomeIcon
                            icon={faUserTie}
                            size="xs"
                            className="me-2"
                          />{" "}
                          FAQ
                        </div>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className={`menu-item `}>
                  <Link to="#" className="menu-link ">
                    <div data-i18n="Dashboard">
                      <FontAwesomeIcon
                        icon={faRadio}
                        size="xs"
                        className="me-2"
                      />{" "}
                      Notifications
                    </div>
                  </Link>
                </li>
              </ul>
            </aside>
          </div>
          <div className="landing-menu-overlay d-lg-none" />
          <ul className="navbar-nav flex-row align-items-center ms-auto">
            <li className="nav-item navbar-dropdown dropdown-user ">
              <Link
                className="nav-link dropdown-toggle hide-arrow"
                to="javascript:void(0);"
                data-bs-toggle="dropdown"
              >
                <div className="avatar avatar-online">
                  <img
                    src={
                      userData?.profile?.profile_pic_url ||
                      "../../assets/img/avatars/14.jpg"
                    }
                    alt
                    style={{
                      borderRadius: "50%",
                    }}
                  />
                </div>
              </Link>
              <ul
                className="dropdown-menu dropdown-menu-end header-menu"
                style={{ position: "absolute !important" }}
              >
                <li>
                  <Link className="dropdown-item">
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar avatar-online">
                          <img
                            src={userData?.profile?.profile_pic_url}
                            alt
                            style={{
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <span className="fw-medium d-block">
                          {userData?.first_name} {userData?.middle_name}{" "}
                          {userData?.last_name}
                        </span>
                        {/* <small className="text-muted">Admin</small> */}
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <div className="dropdown-divider"></div>
                </li>
                <li>
                  <Link className="dropdown-item" to="/profile">
                    <i className="ti ti-user-check me-2 ti-sm"></i>
                    <span className="align-middle">My Profile</span>
                  </Link>
                </li>
                {/* <li>
                  <Link className="dropdown-item" to="#">
                    <i className="ti ti-settings me-2 ti-sm"></i>
                    <span className="align-middle">Settings</span>
                  </Link>
                </li> */}

                <li>
                  <div className="dropdown-divider"></div>
                </li>
                <li>
                  <Link className="dropdown-item" onClick={handleLogout}>
                    <i className="ti ti-chevrons-right me-2 ti-sm"></i>
                    <span className="align-middle">Logout</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
